module.exports = __webpack_public_path__ + "static/media/image10.fdcbb5b3.jpg";